import type { Command } from './types'

export const buildCommand = {
  alert(arg) {
    return {
      name: 'alert',
      timestamp: Date.now(),
      arg,
    }
  },
  log(arg) {
    return {
      name: 'log',
      timestamp: Date.now(),
      arg,
    }
  },
  reload() {
    return {
      name: 'reload',
      timestamp: Date.now(),
      arg: undefined,
    }
  },
  asyncResult(arg) {
    return {
      name: 'asyncResult',
      timestamp: Date.now(),
      arg,
    }
  },
} satisfies Command.BuilderMap

export const defaultCommandCallbacks = {
  reload() {
    window.location.reload()
  },
  alert: ({ message }) => {
    alert(message)
  },
  log: ({ message, level = 'log' }) => {
    console[level]('[ws:cmd]', message ?? '')
  },
} satisfies Partial<Command.CallbackMap>
